import styled from 'styled-components'  

const headerHeight = 105
 
export const DashboardPage = styled.div.attrs({ 
})`            
`;

export const DashboardBody = styled.div.attrs({ 
})`       
    min-height: calc(100vh - ${ headerHeight }px);
    max-height: calc(100vh - ${ headerHeight }px);
    background: var(--white-color);

    display: flex;
    align-items: flex-start;
    overflow:auto;

    /* No celular o menu de cima some, então o conteúdo usa a tela inteira. */
    @media(max-width: 767px){
        min-height: 100vh;
        max-height: 100vh;
    }
`;

export const DashboardBodyContent = styled.div.attrs({ 
})`             
    padding: 35px 20px;
    padding: 0;
    width: 100%;
    min-height: calc(100vh - ${ headerHeight }px);

    /* Espaço extra no fim para o conteúdo não ficar escondido atrás da barra fixa. */
    @media(max-width: 767px){
        min-height: 100vh;
        padding-bottom: calc(78px + env(safe-area-inset-bottom));
    }

    background: var(--white-color);
    ${
        props => props.image ? `
            background: url(${ props.image }) no-repeat center center / cover;
        ` : ``
    }
    ${
        props => props.primary ? `
            background: var(--darkprimary-color);
        ` : ``
    }
`;

export const Content = styled.div.attrs({ 
})`           
`; 